
import { isDefined, runtimeEventManager } from '@wm/core';
import { some } from "lodash-es";
import { getWidgetPropsByType } from "./widget-props";

/**
 * Widget Registry
 */
const registryById = new Map<string, any>();

type RegistryType = Map<string, any>;
const pagewidgetRegistry = new Map<string, RegistryType>();

/**
 * returns the widget by the given widgetId
 */
export const getById = (widgetId: string) => registryById.get(widgetId);

export const getWidgetRegistry = () => {
  return registryById;
}

export const getPageWidgetRegistry = (pageName: any) => {
  return pagewidgetRegistry.get(pageName);
}

export const clearWidgetRegistry = () => {
  registryById.clear();
  nameIdMap = {};
}

export let nameIdMap: {[key: string]: string} = {};

export const setWidgetRegistry = (markup: any, pageName: string) => {
  let wid = markup.getAttribute('widget-id');
  if (!wid) {
    return;
  }
  let widgetType, widgetSubType, wp;
  if (markup.getAttribute('data-role') === 'form-field') {
    widgetType = 'wm-form-field';
    widgetSubType = 'wm-form-field-' + markup.getAttribute('widgetType');
    let displayWidget = markup.getAttribute('displaywidget') || markup.getAttribute('widget') || 'text';
    let liveWidgetUtilsService = runtimeEventManager.getService('LiveWidgetUtilsService');
    wp = liveWidgetUtilsService.getWidgetProps(displayWidget, 'wm-form-field', widgetSubType);
  } else {
    widgetType = markup.getAttribute('widgetType');
    wp = getWidgetPropsByType(widgetType);
  }
  let datasetExpr = markup.getAttribute('dataset.bind');
  let widget = {
    widgetId: wid,
    name: markup.getAttribute('name'),
    widgetType: widgetType,
    nativeElement: markup,
    $element: $(markup),
    widgetProps: wp,
    binddataset: datasetExpr ? 'bind:' + datasetExpr : '',
    type: markup.getAttribute('type')
  };
  registryById.set(wid, widget);
  pagewidgetRegistry.set(pageName, new Map(registryById));
}

/**
 * Registers the Widget with the given id and name
 * Makes the Widget available with the viewParent
 * returns unRegister method
 */
export const register = (widget: any, viewParent: any, pageName: string, widgetId?: string | null, name?: string): () => void => {
  let registered = false;
  if (widgetId) {
    registryById.set(widgetId, widget);
    pagewidgetRegistry.set(pageName, new Map(registryById));
    nameIdMap[name || widget.name] = widgetId;
  }
  if (name) {
    if (viewParent && isDefined(viewParent.Widgets)) {
      registered = true;
      viewParent.Widgets[name] = widget;
    }
  }

  // Unregister method.
  return () => {
    if (widgetId) {
      registryById.delete(widgetId);
      some(nameIdMap, (val, name) => {
        if (val === widgetId) {
          delete nameIdMap[name];
          return true;
        }
        return false;
      });
    }
    if (registered) {
      if (name) {
        viewParent.Widgets[name] = undefined;
        delete viewParent.Widgets[name];
      }
    }
  };
};


/**
 * Deregisters the oldname in widgets registry and sets new name
 */
export const renameWidget = (viewParent: any, widget: any, nv: string, ov?: string) => {
  runtimeEventManager.emit('widget-name', {widgetId: widget.widgetId, name: nv});
  if (!isDefined(viewParent?.Widgets)) {
    return;
  }
  if (ov) {
    viewParent.Widgets[ov] = undefined;
  }
  if (nv) {
    viewParent.Widgets[nv] = widget;
  }
};
